import Bowser from 'bowser/bundled';

const isIe = () => {
  const browser = Bowser.getParser(window.navigator.userAgent);
  const platform = browser.parsedResult.browser.name;
  let answer = false;

  if (platform === 'Internet Explorer') {
    answer = true;
  }
  return answer;
};

export default isIe;
